module.exports = __webpack_public_path__ + "files/748e7faadb4e030c8adf65c421a426d3.png";